import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EnumLanguage } from '@libs/constants';
import { Util } from '@libs/utilities/util';
import { Subscription } from 'rxjs';
import { AddonLanguageTranslationService } from '@domains/frontend/page-addons';

import { LegalCookiesBannerStorageHandler } from '../../../services/cookies-banner/cookies-storage/cookies-storage.handler';
import { ILegalCookieSettingsData, LEGAL_COOKIE_PREFERENCES_DATA } from './cookies-usage.data';


@Component({
    selector: 'legal-cookies-settings',
    templateUrl: './cookies-settings.component.html',
    styleUrls: ['./cookies-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, FormsModule]
})
export class LegalCookiesSettingsComponent implements OnInit, OnDestroy {

	@Input() showDescriptions: boolean = true;

	//** Output properties */
	@Output() readonly socialMediaCookiesChange	: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() readonly analyticalCookiesChange	: EventEmitter<boolean> = new EventEmitter<boolean>();

	//** UI Helpers */
	socialMediaCookies		 	: boolean = false;
	analyticsCookies		 	: boolean = false;
	legalCookiesSettingsData 	: ILegalCookieSettingsData;
	languageServiceSubscription : Subscription;


	constructor(
		private cdr 						: ChangeDetectorRef,
		private translationService 			: AddonLanguageTranslationService,
		private cookiesBannerStorageHandler : LegalCookiesBannerStorageHandler
	) {}

	ngOnInit(): void {

		//0 - get data by language
		this.languageServiceSubscription = this.translationService.getTranslationObservable().subscribe((language: EnumLanguage) => {

			// is valid language
			if (!Util.Enum.isValid(EnumLanguage, language)) throw new Error(`LegalCookiesSettingsComponent => ngOnInit => FATAL ERROR: selectedLanguage is not valid ${language}`);
			this.legalCookiesSettingsData = LEGAL_COOKIE_PREFERENCES_DATA[language]!;
			this.cdr.detectChanges();
		});

		//1 - set the cookies
		this.socialMediaCookies = Util.Basic.isBrowser() ? this.cookiesBannerStorageHandler.hasAcceptedSocialMedia() : false;
		this.analyticsCookies	= Util.Basic.isBrowser() ? this.cookiesBannerStorageHandler.hasAcceptedAnalytics() : false;
	}

	ngOnDestroy(): void {
		this.languageServiceSubscription.unsubscribe();
	}

	updateSocialMediaCookies(): void {
		this.socialMediaCookiesChange.emit(this.socialMediaCookies);
	}

	updateAnalyticalCookies(): void {
		this.analyticalCookiesChange.emit(this.analyticsCookies);
	}
}
